var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['proposition-buttons-container', { onboarding: _vm.isOnboarding }]},[_c('InterestToggle',{attrs:{"interested":_vm.interested,"toggle-interest":_vm.markInterest,"is-loading":_vm.isLoading},on:{"toggleConversionModal":() => _vm.$emit('toggleConversionModal')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }